import { useMutation, useQueryClient } from "@tanstack/react-query";

import { postMerchantsPublicIDEmployeesEmployeePublicIDCancelAccess } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { merchantEmployeeKeys } from "Api/Queries/Merchants/Employees/useMerchantEmployee";
import { merchantEmployeesKeys } from "Api/Queries/Merchants/Employees/useMerchantEmployees";
import { toast } from "sonner";
import { useResource, Resources } from "Translations/Resources";

const RESOURCES = Resources.Hooks.Employee;

type Parameters = {
  publicID: string;
  employeePublicID: string;
};

type Props = {
  onSuccess?: () => void;
  onError?: () => void;
};

export const useCancelEmployeeAccessMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();
  const { t } = useResource();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      ({ publicID, employeePublicID }: Parameters) =>
        postMerchantsPublicIDEmployeesEmployeePublicIDCancelAccess(
          publicID,
          employeePublicID,
        ),
    ),
    onSuccess: (_: unknown, { publicID, employeePublicID }: Parameters) => {
      // The list page queries without a merchant id, so invalidate every list, not list(publicID).
      queryClient.invalidateQueries({
        queryKey: merchantEmployeesKeys.lists(),
      });
      queryClient.invalidateQueries({
        queryKey: merchantEmployeeKeys.singleEmployee(
          publicID,
          employeePublicID,
        ),
      });
      toast.success(t(RESOURCES.InvitationCancelled));
      onSuccess?.();
    },
    onError: () => {
      onError?.();
      toast.error(t(RESOURCES.InvitationCancelError));
    },
  });
};
